module.exports = "/static-assets/_next/static/images/frame-d51faac7f6fcbc5a8b2370f23cac4895.png";